import { Nullable } from "@tager/admin-services";
import { OptionType, SingleFileInputValueType } from "@tager/admin-ui";

import { BrandType, FullCollectionType } from "@/typings/model";
import {
  CollectionCreationPayload,
  CollectionUpdatePayload,
} from "@/services/requests";
import { createFileInputValue } from "@/utils/common";

export type FormValues = {
  name: string;
  urlAlias: string;
  brand: Nullable<OptionType<number>>;
  content: string;
  image: Nullable<SingleFileInputValueType>;
  pageDescription: string;
  openGraphImage: Nullable<SingleFileInputValueType>;
  pageTitle: string;
};

export function convertCollectionToFormValues(
  collection: Nullable<FullCollectionType>,
  brandOption: Nullable<Array<OptionType<number>>>
): FormValues {
  if (!collection) {
    return {
      name: "",
      urlAlias: "",
      brand: null,
      content: "",
      image: null,
      pageDescription: "",
      openGraphImage: null,
      pageTitle: "",
    };
  }

  const currentBrandOption = brandOption?.find(
    (option) => option.value === collection.brandId
  );

  return {
    name: collection.name ?? "",
    urlAlias: collection.urlAlias ?? "",
    brand: currentBrandOption ?? null,
    content: collection.content ?? "",
    image: collection.image ? createFileInputValue(collection.image) : null,
    pageDescription: collection.pageDescription ?? "",
    openGraphImage: collection.openGraphImage
      ? createFileInputValue(collection.openGraphImage)
      : null,
    pageTitle: collection.pageTitle ?? "",
  };
}

export function convertFormValuesToCollectionCreationPayload(
  values: FormValues
): CollectionCreationPayload {
  return {
    name: values.name ?? "",
    brandId: values.brand?.value ?? null,
    content: values.content ?? "",
    image: values.image?.file.id ?? null,
    pageDescription: values.pageDescription ?? "",
    openGraphImage: values.openGraphImage?.file.id ?? null,
    pageTitle: values.pageTitle ?? "",
  };
}

export function convertFormValuesToCollectionUpdatePayload(
  values: FormValues
): CollectionUpdatePayload {
  return {
    urlAlias: values.urlAlias ?? "",
    ...convertFormValuesToCollectionCreationPayload(values),
  };
}

export function convertBrandListToOption(
  brandList: Array<BrandType>
): Array<OptionType<number>> {
  return brandList.map((brand) => ({
    value: brand.id,
    label: brand.name,
  }));
}
